// Generated by CoffeeScript 2.7.0
var ReactiveCalculationMixin;

export default ReactiveCalculationMixin = {
  created: function() {
    return this.calculationSandbox = new Skylark.Libs.CalculationSandbox();
  },
  mounted: function() {
    return this.onValueChangedFunc();
  },
  methods: {
    onValueChangedFunc: function(fieldVm) {
      if (!this.hasCalculationFields) {
        return;
      }
      if (fieldVm && fieldVm.field.type === "Field::Calculation") {
        return;
      }
      return this.$nextTick(function() {
        var raw_response;
        raw_response = this.__generateRawResponseForCalculation(this.$refs.fieldsView.fieldChildren);
        return this.calculationSandbox.calculate(raw_response, (result) => {
          if (result === 'timeout') {
            return this.__setErrorOnCalculationFields(this.$refs.fieldsView);
          } else {
            return this.__setComputedValues(this.$refs.fieldsView, result);
          }
        });
      });
    },
    __generateRawResponseForCalculation: function(fieldVms) {
      return _.reduce(fieldVms, function(acc, fieldVm) {
        var identity_key, value;
        identity_key = fieldVm.field.identity_key;
        if (!_.isUndefined(identity_key)) {
          switch (fieldVm.field.type) {
            case 'Field::SectionBreak':
            case 'Field::Page':
              break;
            default:
              value = fieldVm.valueForCalculation;
              if (value) {
                acc[identity_key] = value;
              }
          }
        }
        return acc;
      }, {});
    },
    __setErrorOnCalculationFields: function(fieldsView) {
      var setError;
      setError = function(fieldVms, errorMessage) {
        return _.each(fieldVms, (fieldVm) => {
          if (fieldVm.field.type === 'Field::Detail') {
            return _.each(fieldVm.groupViewChilden, function(groupVm) {
              return setError(groupVm.groupedFieldList.fieldChildren, errorMessage);
            });
          } else if (fieldVm.field.type === 'Field::Calculation') {
            fieldVm.valueChange(null);
            return fieldVm._addError(errorMessage);
          }
        });
      };
      return setError(fieldsView.fieldChildren, '计算超时，请重试');
    },
    __setComputedValues: function(fieldsView, result) {
      _.each(result.data, (value, path) => {
        var fieldVm;
        fieldVm = this.__findFieldVmByPath(fieldsView.fieldChildren, path);
        if (fieldVm) {
          return fieldVm.valueChange(value);
        }
      });
      return _.each(result.errors, (error, path) => {
        var fieldVm;
        fieldVm = this.__findFieldVmByPath(fieldsView.fieldChildren, path);
        if (fieldVm) {
          fieldVm.valueChange(null);
          return fieldVm._addError(error);
        }
      });
    },
    __findFieldVmByPath: function(fieldVms, path) {
      var child_identity_key, fieldVm, groupVm, group_id, identity_key;
      [identity_key, group_id, child_identity_key] = path.split('.');
      fieldVm = this.__findFieldVm(fieldVms, identity_key);
      if (fieldVm.field.type === 'Field::Detail') {
        groupVm = _.find(fieldVm.groupViewChilden, function(vm) {
          return String(vm.group.id) === group_id;
        });
        if (groupVm) {
          return this.__findFieldVm(groupVm.groupedFieldList.fieldChildren, child_identity_key);
        }
      } else {
        return fieldVm;
      }
    },
    __findFieldVm: function(fieldVms, identity_key) {
      return _.find(fieldVms, function(fieldVm) {
        return fieldVm.field.identity_key === identity_key;
      });
    }
  }
};
